module.exports = __webpack_public_path__ + "assets/img/4_83_big.b36a511f.jpg";